import { useRemoteClientPost } from '@/configs/http-client';
import { Endpoints } from '@/remote/endpoints';
import { useLocalStorage } from '@/remote/local-storage';
import { DataTablePlans } from '@/view/components/data-table-plans';
import { PaginationDemo } from '@/view/components/pagination';
import { usePagination } from '@/view/hooks';
import { usePromiseToast } from '@/view/hooks/toast-promisse';
import { PlanFormData } from '@/view/validators/plan-validator';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';



export function DisplayPlans() {

  const { httpClientPost } = useRemoteClientPost()
  const { triggerToast } = usePromiseToast()
  const { backPage, nextPage } = usePagination()
  const { getUnitId } = useLocalStorage()
  const [params] = useSearchParams()
  const [data, setData] = useState<PlanFormData[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [pageInfo, setPageInfo] = useState({
    page: 0,
    total: 0,
    totalPages: 0
  })

  const ITEMS_PER_PAGE = 20

  const updatePageInfo = (responseData: any) => {
    const content = responseData?.content ?? []
    const page = responseData?.pageable?.pageNumber ?? 0
    const totalPages = responseData?.totalPages ?? 0
    const total = responseData?.totalElements ?? 0

    setData(content)
    setPageInfo({
      page,
      total,
      totalPages
    })
  }

  const fetchData = async () => {
    try {
      setIsLoading(true)
      // const response = await remoteClientGet(
      //   Endpoints.plans,
      //   formatParams({
      //     page: pageInfo.page,
      //     size: ITEMS_PER_PAGE,
      //     sortParam: 'id',
      //     order: 'desc',
      //     unidadeId: params.get('unit') || getUnitId()
      //   })
      // )

      const response = await httpClientPost(`${Endpoints.plans}/filtro?page=${pageInfo.page}&size=${ITEMS_PER_PAGE}&order=desc&sort=id`, {
        idUnidade: params.get('id') ?? getUnitId(),
      });


      updatePageInfo(response?.data?.data)
    } catch (error) {
      console.error('Erro ao buscar dados:', error)
      throw error
    } finally {
      setIsLoading(false)
    }
  }

  const handlePageNavigation = (newPage: number) => {
    if (newPage >= 0 && newPage < pageInfo.totalPages) {
      setPageInfo(prev => ({ ...prev, page: newPage }))
    }
  }

  const handleNextPage = () => {
    nextPage(pageInfo.page, pageInfo.totalPages, (newPage) => {
      handlePageNavigation(newPage)
    })
  }

  const handlePreviousPage = () => {
    backPage(pageInfo.page, (newPage) => {
      handlePageNavigation(newPage)
    })
  }

  const handleRefresh = () => {
    triggerToast(fetchData())
  }

  useEffect(() => {
    handleRefresh()
  }, [pageInfo.page, params])

  return (
    <div className="space-y-4">
      {isLoading ? (
        <div className="flex justify-center py-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" />
        </div>
      ) : (
        <>
          <DataTablePlans
            data={data}
            getRefreshList={handleRefresh}
          />

          {data.length > 0 && (
            <PaginationDemo
              totalForPage={ITEMS_PER_PAGE}
              back={handlePreviousPage}
              next={handleNextPage}
              page={pageInfo.page}
              total={pageInfo.total}
              labelItem='planos'
            />
          )}
        </>
      )}
    </div>
  )
}